module.exports = __webpack_public_path__ + "img/Group 1040one.f27473d2.png";